export const ACTIVITY_CLEANUP_PERIOD_DURATION = 7
